import { Sparkles, Crown, Layers, Camera, Check } from "lucide-react";
import { EXPERTISE } from "../../data/mock";

const ICONS = {
  brand: Sparkles,
  consulting: Crown,
  product: Layers,
  modeling: Camera,
};

export default function Expertise() {
  return (
    <section
      id="expertise"
      data-testid="expertise-section"
      className="py-24 md:py-32 bg-cream-alt border-y border-[#E5E0D8]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="max-w-3xl">
          <span className="eyebrow" data-testid="expertise-eyebrow">What I do</span>
          <h2
            data-testid="expertise-heading"
            className="font-display text-4xl md:text-5xl lg:text-[56px] leading-[1.05] mt-6 text-navy"
          >
            Four practices,
            <span className="italic text-terracotta"> one perspective.</span>
          </h2>
          <p className="mt-6 text-lg text-ink-muted max-w-2xl">
            My work moves between strategy, craft, and storytelling — all in service of
            people becoming more themselves, on the page and in the room.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-6 md:gap-8">
          {EXPERTISE.map((item, i) => {
            const Icon = ICONS[item.id] || Sparkles;
            return (
              <article
                key={item.id}
                data-testid={`expertise-card-${item.id}`}
                className="card-soft p-8 md:p-10 flex flex-col"
              >
                <div className="flex items-start justify-between">
                  <div className="w-14 h-14 bg-cream flex items-center justify-center border border-[#E5E0D8]">
                    <Icon size={26} className="text-terracotta" strokeWidth={1.6} />
                  </div>
                  <span className="font-display italic text-sm text-mustard-deep" style={{color: '#B47F2C'}}>
                    0{i + 1}
                  </span>
                </div>
                <h3
                  data-testid={`expertise-title-${item.id}`}
                  className="font-display text-2xl md:text-3xl mt-6 text-navy"
                >
                  {item.title}
                </h3>
                <p className="mt-3 text-[17px] text-ink-muted leading-relaxed">
                  {item.description}
                </p>
                <ul className="mt-6 space-y-2.5 pt-6 border-t border-[#E5E0D8]">
                  {item.bullets.map((b) => (
                    <li
                      key={b}
                      className="flex items-center gap-3 text-[15px] text-navy"
                    >
                      <Check size={16} className="text-terracotta flex-shrink-0" />
                      {b}
                    </li>
                  ))}
                </ul>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
